import { getToken, returnError } from './helperFunc';
import {
	getCoinCollectionAction,
	addCoinCollectionAction,
	assignCoinCollectionAction,
	editCoinCollectionAction,
	deleteCoinCollectionAction,
	//
	machineCutoffStartAction,
	stockAdjustmentStartAction,
	machineCutoffAction,
	machineCutoffSubmitAction,
	machineCutoffListAction,
	getMachineCutoffHistoryAction,
	getCutoffStatusAction,
	machineCutoffBillSubmitAction,
	coinCollectionSubmitAction,
	coinCollectionReceiptAction,
	getPreviousCutoffAction,
	machineCutoffEditAction,
	getChemicalTypesAction,
	getCostingTypesAction,
	recalculateCoinCollectionAction,
	machineCutoffListActionv2,
	machineCutoffBillSubmitActionv2,
	billInvoiceSaveAction,
	coinCollectionSubmitActionv2,
	coinCollectionSubmitActionv3
} from './requestEndpoints';

import { LOGOUT_SUCCESS } from './userReducer';

const SET_LOADING_COIN = 'SET_LOADING_COIN';
const CLEAR_ERROR_COIN = 'CLEAR_ERROR_COIN';

const ADD_COIN_COLLECTION_SUCCESS = 'ADD_COIN_COLLECTION_SUCCESS';
const ADD_COIN_COLLECTION_FAIL = 'ADD_COIN_COLLECTION_FAIL';

const ASSIGN_COIN_COLLECTION_SUCCESS = 'ASSIGN_COIN_COLLECTION_SUCCESS';
const ASSIGN_COIN_COLLECTION_FAIL = 'ASSIGN_COIN_COLLECTION_FAIL';

const DELETE_COIN_COLLECTION_SUCCESS = 'DELETE_COIN_COLLECTION_SUCCESS';
const DELETE_COIN_COLLECTION_FAIL = 'DELETE_COIN_COLLECTION_FAIL';

const UPDATE_COIN_COLLECTION_SUCCESS = 'UPDATE_COIN_COLLECTION_SUCCESS';
const UPDATE_COIN_COLLECTION_FAIL = 'UPDATE_COIN_COLLECTION_FAIL';

const GET_COIN_COLLECTIONS_SUCCESS = 'GET_COIN_COLLECTIONS_SUCCESS';
const GET_COIN_COLLECTIONS_FAIL = 'GET_COIN_COLLECTIONS_FAIL';

const SAVE_BILL_INVOICE_SUCCESS = 'SAVE_BILL_INVOICE_SUCCESS';
const SAVE_BILL_INVOICE_FAIL = 'SAVE_BILL_INVOICE_FAIL';

// coin_collection/dashboard

// FOR PRICE SETTING

export const getCoinCollectionList = (outletId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_COIN });
		dispatch({ type: SET_LOADING_COIN });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await getCoinCollectionAction(outletId, token);

		dispatch({ type: GET_COIN_COLLECTIONS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: GET_COIN_COLLECTIONS_FAIL,
			payload: returnError(error),
		});
	}
};

export const addCoinCollection = (newPrice) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_COIN });
		dispatch({ type: SET_LOADING_COIN });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await addCoinCollectionAction(newPrice, token);

		dispatch({ type: ADD_COIN_COLLECTION_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: ADD_COIN_COLLECTION_FAIL, payload: returnError(error) });
	}
};

export const assignCoinCollection = (newPrice) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_COIN });
		dispatch({ type: SET_LOADING_COIN });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await assignCoinCollectionAction(newPrice, token);

		dispatch({ type: ASSIGN_COIN_COLLECTION_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: ASSIGN_COIN_COLLECTION_FAIL,
			payload: returnError(error),
		});
	}
};

export const updateCoinCollection = (updateData) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_COIN });
		dispatch({ type: SET_LOADING_COIN });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await editCoinCollectionAction(updateData, token);

		dispatch({ type: UPDATE_COIN_COLLECTION_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: UPDATE_COIN_COLLECTION_FAIL,
			payload: returnError(error),
		});
	}
};

export const deleteCoinCollection = (id) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_COIN });
		dispatch({ type: SET_LOADING_COIN });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await deleteCoinCollectionAction(id, token);

		dispatch({ type: DELETE_COIN_COLLECTION_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: DELETE_COIN_COLLECTION_FAIL,
			payload: returnError(error),
		});
	}
};

export const saveBillInvoice = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await billInvoiceSaveAction(dataBody, token);

		dispatch({ type: SAVE_BILL_INVOICE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: SAVE_BILL_INVOICE_FAIL, payload: returnError(error) });
	}
};

const initialState = {
	language: 'en',
	loading: false,
	coinCollections: [],
};

export const coinCollectorReducer = function (state = initialState, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_LOADING_COIN:
			return {
				...state,
				loading: true,
			};

		case CLEAR_ERROR_COIN:
			return {
				...state,
				error: null,
				loading: false,
			};

		case GET_COIN_COLLECTIONS_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				coinCollections: action.payload.data,
				loading: false,
				error: null,
			};
		case ADD_COIN_COLLECTION_SUCCESS:
			return {
				...state,
				coinCollection: action.payload.data,
				loading: false,
				error: null,
			};
		case ASSIGN_COIN_COLLECTION_SUCCESS:
			return {
				...state,
				assigned: action.payload.data,
				loading: false,
				error: null,
			};
		case UPDATE_COIN_COLLECTION_SUCCESS:
			return {
				...state,
				coinCollectionUpdated: action.payload.data,
				loading: false,
				error: null,
				success: true,
			};
		case DELETE_COIN_COLLECTION_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				removed: true,
			};
		case LOGOUT_SUCCESS:
			return initialState;

		case ASSIGN_COIN_COLLECTION_FAIL:
		case UPDATE_COIN_COLLECTION_FAIL:
		case DELETE_COIN_COLLECTION_FAIL:
		case GET_COIN_COLLECTIONS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};

const SET_LOADING_CUTOFF = 'SET_LOADING_CUTOFF';
const CLEAR_ERROR_CUTOFF = 'CLEAR_ERROR_CUTOFF';

const CUTOFF_START_SUCCESS = 'CUTOFF_START_SUCCESS';
const CUTOFF_START_FAIL = 'CUTOFF_START_FAIL';

const CUTOFF_SUCCESS = 'CUTOFF_SUCCESS';
const CUTOFF_FAIL = 'CUTOFF_FAIL';

const CUTOFF_SUBMIT_SUCCESS = 'CUTOFF_SUBMIT_SUCCESS';
const CUTOFF_SUBMIT_FAIL = 'CUTOFF_SUBMIT_FAIL';

const CUTOFF_EDIT_SUCCESS = 'CUTOFF_EDIT_SUCCESS';
const CUTOFF_EDIT_FAIL = 'CUTOFF_EDIT_FAIL';

const GET_CUTOFF_LIST_SUCCESS = 'GET_CUTOFF_LIST_SUCCESS';
const GET_CUTOFF_LIST_FAIL = 'GET_CUTOFF_LIST_FAIL';

const GET_CUTOFF_STATUS_SUCCESS = 'GET_CUTOFF_STATUS_SUCCESS';
const GET_CUTOFF_STATUS_FAIL = 'GET_CUTOFF_STATUS_FAIL';

const GET_CUTOFF_PREVIOUS_STATUS_SUCCESS = 'GET_CUTOFF_PREVIOUS_STATUS_SUCCESS';
const GET_CUTOFF_PREVIOUS_STATUS_FAIL = 'GET_CUTOFF_PREVIOUS_STATUS_FAIL';

const GET_CUTOFF_HISTORY_SUCCESS = 'GET_CUTOFF_HISTORY_SUCCESS';
const GET_CUTOFF_HISTORY_FAIL = 'GET_CUTOFF_HISTORY_FAIL';

const COIN_COLLECTION_SUBMIT_SUCCESS = 'COIN_COLLECTION_SUBMIT_SUCCESS';
const COIN_COLLECTION_SUBMIT_FAIL = 'COIN_COLLECTION_SUBMIT_FAIL';

const GET_CHEMICAL_TYPES_SUCCESS = 'GET_CHEMICAL_TYPES_SUCCESS';
const GET_CHEMICAL_TYPES_FAIL = 'GET_CHEMICAL_TYPES_FAIL';

const GET_COSTING_TYPES_SUCCESS = 'GET_COSTING_TYPES_SUCCESS';
const GET_COSTING_TYPES_FAIL = 'GET_COSTING_TYPES_FAIL';

const RECALCULATE_COIN_COLLECTION_SUCCESS = 'RECALCULATE_COIN_COLLECTION_SUCCESS';
const RECALCULATE_COIN_COLLECTION_FAIL = 'RECALCULATE_COIN_COLLECTION_FAIL';

const GET_COIN_COLLECTION_RECEIPT_SUCCESS = 'GET_COIN_COLLECTION_RECEIPT_SUCCESS';
const GET_COIN_COLLECTION_RECEIPT_FAIL = 'GET_COIN_COLLECTION_RECEIPT_FAIL';

export const machineCutoffStart = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineCutoffStartAction(dataBody, token);

		dispatch({ type: CUTOFF_START_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CUTOFF_START_FAIL, payload: returnError(error) });
	}
};

export const stockAdjustmentStart = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await stockAdjustmentStartAction(dataBody, token);

		dispatch({ type: CUTOFF_START_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CUTOFF_START_FAIL, payload: returnError(error) });
	}
};

export const machineCutoff = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineCutoffAction(dataBody, token);

		dispatch({ type: CUTOFF_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CUTOFF_FAIL, payload: returnError(error) });
	}
};

export const machineCutoffSubmit = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineCutoffSubmitAction(dataBody, token);

		dispatch({ type: CUTOFF_SUBMIT_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CUTOFF_SUBMIT_FAIL, payload: returnError(error) });
	}
};

export const machineCutoffEdit = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineCutoffEditAction(dataBody, token);

		dispatch({ type: CUTOFF_EDIT_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CUTOFF_EDIT_FAIL, payload: returnError(error) });
	}
};

export const machineBillCutoffSubmit = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineCutoffBillSubmitAction(dataBody, token);

		dispatch({ type: CUTOFF_SUBMIT_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CUTOFF_SUBMIT_FAIL, payload: returnError(error) });
	}
};

export const machineBillCutoffSubmitv2 = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineCutoffBillSubmitActionv2(dataBody, token);

		dispatch({ type: CUTOFF_SUBMIT_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CUTOFF_SUBMIT_FAIL, payload: returnError(error) });
	}
};

export const machineCutoffList = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineCutoffListAction(dataBody, token);

		dispatch({ type: GET_CUTOFF_LIST_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_CUTOFF_LIST_FAIL, payload: returnError(error) });
	}
};

export const machineCutoffListv2 = (dataBody) => async (dispatch, getState) => {
	console.log('machineCutoffListv2 dataBody', dataBody);
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineCutoffListActionv2(dataBody, token);

		dispatch({ type: GET_CUTOFF_LIST_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_CUTOFF_LIST_FAIL, payload: returnError(error) });
	}
};

export const getMachineCutoffHistory = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await getMachineCutoffHistoryAction(dataBody, token);

		dispatch({ type: GET_CUTOFF_HISTORY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_CUTOFF_HISTORY_FAIL, payload: returnError(error) });
	}
};

export const getMachineCutoffStatus = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await getCutoffStatusAction(dataBody, token);

		dispatch({ type: GET_CUTOFF_STATUS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_CUTOFF_STATUS_FAIL, payload: returnError(error) });
	}
};

export const getPreviousCutoffInfo = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await getPreviousCutoffAction(dataBody, token);

		dispatch({ type: GET_CUTOFF_PREVIOUS_STATUS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_CUTOFF_PREVIOUS_STATUS_FAIL , payload: returnError(error) });
	}
};

export const coinCollectionSubmit = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await coinCollectionSubmitAction(dataBody, token);

		dispatch({ type: COIN_COLLECTION_SUBMIT_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: COIN_COLLECTION_SUBMIT_FAIL, payload: returnError(error) });
	}
};

export const coinCollectionSubmitv2 = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await coinCollectionSubmitActionv2(dataBody, token);

		dispatch({ type: COIN_COLLECTION_SUBMIT_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: COIN_COLLECTION_SUBMIT_FAIL, payload: returnError(error) });
	}
};

export const coinCollectionSubmitv3 = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await coinCollectionSubmitActionv3(dataBody, token);

		dispatch({ type: COIN_COLLECTION_SUBMIT_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: COIN_COLLECTION_SUBMIT_FAIL, payload: returnError(error) });
	}
};

export const getChemicalTypes = (outletId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_COIN });
		dispatch({ type: SET_LOADING_COIN });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await getChemicalTypesAction(outletId, token);

		dispatch({ type: GET_CHEMICAL_TYPES_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: GET_CHEMICAL_TYPES_FAIL,
			payload: returnError(error),
		});
	}
};

export const getCostingTypes = (outletId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_COIN });
		dispatch({ type: SET_LOADING_COIN });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await getCostingTypesAction(outletId, token);

		dispatch({ type: GET_COSTING_TYPES_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: GET_COSTING_TYPES_FAIL,
			payload: returnError(error),
		});
	}
};

export const recalculateCoinCollection = (coinCollectionId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await recalculateCoinCollectionAction(coinCollectionId, token);

		dispatch({ type: RECALCULATE_COIN_COLLECTION_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: RECALCULATE_COIN_COLLECTION_FAIL, payload: returnError(error) });
	}
};

export const getCoinCollectionReceipt = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CUTOFF });
		dispatch({ type: SET_LOADING_CUTOFF });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await coinCollectionReceiptAction(dataBody, token);

		dispatch({ type: GET_COIN_COLLECTION_RECEIPT_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_COIN_COLLECTION_RECEIPT_FAIL, payload: returnError(error) });
	}
};

const initialState2 = {
	language: 'en',
	loading: false,
	machineCutoff: '',
	machineCutoffLists: [],
	error: null,
	coinCollectionCompleted: null,
	cutoffs: null,
	chemicalTypes: [],
	costingTypes: [],
	utilities: [],
	minibox: [],
	carryForwardInitialStock: [],
	coinCollectionReceipt: null,
};

export const machineCutOffReducer = function (state = initialState2, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_LOADING_CUTOFF:
			return {
				...state,
				loading: true,
			};

		case CLEAR_ERROR_CUTOFF:
			return {
				...state,
				error: null,
				coinCollectionCompleted: null,
				loading: false,
				cutoffStart: null,
			};

		case CUTOFF_START_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				cutoffStart: action.payload.data,
				loading: false,
				error: null,
			};
		case CUTOFF_SUCCESS:
			return {
				...state,
				cutoffSuccess: action.payload.data,
				loading: false,
				error: null,
			};
		case CUTOFF_SUBMIT_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				cutoffSubmit: action.payload.data,
				cutoffAmountData: action.payload.cutoffData,
				loading: false,
				error: null,
			};
		case CUTOFF_EDIT_SUCCESS:
				// console.log('action.payload', action.payload);
			return {
				...state,
				cutoffSubmit: action.payload.data,
				cutoffAmountData: action.payload.cutoffData,
				loading: false,
				error: null,
			};
		case COIN_COLLECTION_SUBMIT_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				cutoffAmountData: null,
				machineCutoffStatus: action.payload.data,
				coinCollectionCompleted: action.payload.coinCollectionCompleted,
				vendingData: action.payload.vending,
				loading: false,
				error: null,
				utilities: action.payload.utilities,
				minibox: action.payload.minibox,
				carryForwardInitialStock: action.payload.carryForwardInitialStock,
			};
		case GET_CUTOFF_LIST_SUCCESS:
			return {
				...state,
				machineCutoffLists: action.payload.data,
				loading: false,
				error: null,
			};
		case GET_CUTOFF_HISTORY_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				machineCutoffHistory: action.payload.data,
				cutoffData: action.payload.cutoffData,
				coinBoxData: action.payload.coinBoxData,
				loading: false,
				error: null,
			};
		case GET_CUTOFF_STATUS_SUCCESS:
			return {
				...state,
				cutoffAmountData: null,
				machineCutoffStatus: action.payload.data,
				coinCollectionCompleted: action.payload.coinCollectionCompleted,
				vendingData: action.payload.vending,
				loading: false,
				error: null,
				utilities: action.payload.utilities,
				minibox: action.payload.minibox,
				carryForwardInitialStock: action.payload.carryForwardInitialStock,
			};
		case GET_CUTOFF_PREVIOUS_STATUS_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				cutoffs: action.payload.cutoffs,
				loading: false,
				error: null,
			};
		case GET_CHEMICAL_TYPES_SUCCESS:
			return {
				...state,
				chemicalTypes: action.payload.data,
				loading: false,
				error: null,
			};
		case GET_COSTING_TYPES_SUCCESS:
			return {
				...state,
				costingTypes: action.payload.data,
				loading: false,
				error: null,
			};
		case RECALCULATE_COIN_COLLECTION_SUCCESS:
			return {
				...state,
				recalculateSuccess: true,
				loading: false,
				error: null,
			};
		case GET_COIN_COLLECTION_RECEIPT_SUCCESS:
			return {
				...state,
				coinCollectionReceipt: {
					...action.payload.data,
					coinBoxData: action.payload.coinBoxData || [],
				},
				loading: false,
				error: null,
			};
		case SAVE_BILL_INVOICE_SUCCESS:
			return {
				...state,
				billInvoiceSaved: action.payload.cutoff,
				loading: false,
				error: null,
			};
		case GET_CHEMICAL_TYPES_FAIL:
		case GET_COSTING_TYPES_FAIL:
		case RECALCULATE_COIN_COLLECTION_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case LOGOUT_SUCCESS:
			return initialState2;

		case CUTOFF_START_FAIL:
		case CUTOFF_FAIL:
		case CUTOFF_SUBMIT_FAIL:
		case CUTOFF_EDIT_FAIL:
		case COIN_COLLECTION_SUBMIT_FAIL:
		case GET_CUTOFF_LIST_FAIL:
		case GET_CUTOFF_HISTORY_FAIL:
		case GET_COIN_COLLECTION_RECEIPT_FAIL:
		case SAVE_BILL_INVOICE_FAIL:
			return {
				...state,
				cutoffSubmit: null,
				cutoffAmountData: null,
				loading: false,
				error: action.payload,
				coinCollectionCompleted: null,
				cutoffs: null,
			};

		default:
			return state;
	}
};
